import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import React from "react";

const useStyles = makeThemedStyles("ProgressModal.complete", (theme) => ({
  outerContainer: {
    width: "110px",
    height: "110px",
    border: "1px solid rgba(76, 81, 87, 0.13)",
    borderRadius: "100px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  checkIconStyle: {
    width: "60px",
    height: "60px",
    color: "linear-gradient(91.14deg, #00A9A3 0.97%, #43DDD8 99.03%)",
    boxShadow: "-3px 3px 10px rgba(0, 169, 163, 0.17",
  },
}));
const ProcessComplete = () => {
  const style = useStyles();
  return (
    <div className={style.outerContainer}>
      <svg width="0" height="0">
        <linearGradient id="icon-gradient" x1="100%" y1="100%" x2="0%" y2="0%">
          <stop stopColor="#0e9cf0ff" offset="0%" />
          <stop stopColor="#0e9cf088" offset="100%" />
        </linearGradient>
      </svg>
      <CheckCircleIcon
        style={{ fill: "url(#icon-gradient)" }}
        className={style.checkIconStyle}
      />
    </div>
  );
};

export default ProcessComplete;
